//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class ArchiveService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getSites(): Observable<ArchivedSiteDtoListApiResponse> {
        let url_ = this.baseUrl + "/api/archive/sites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchivedSiteDtoListApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchivedSiteDtoListApiResponse>;
        }));
    }

    protected processGetSites(response: HttpResponseBase): Observable<ArchivedSiteDtoListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArchivedSiteDtoListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArchivedSiteDtoListApiResponse>(null as any);
    }

    /**
     * @return No Content
     */
    restoreSite(siteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/archive/sites/{siteId}/restore";
        if (siteId === undefined || siteId === null)
            throw new globalThis.Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestoreSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    signIn(body: SignInRequest | undefined): Observable<SignInResponseApiResponse> {
        let url_ = this.baseUrl + "/api/auth/sign-in";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SignInResponseApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SignInResponseApiResponse>;
        }));
    }

    protected processSignIn(response: HttpResponseBase): Observable<SignInResponseApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignInResponseApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignInResponseApiResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProfileService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(): Observable<ProfileDtoApiResponse> {
        let url_ = this.baseUrl + "/api/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileDtoApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileDtoApiResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProfileDtoApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileDtoApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfileDtoApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateProfileRequest | undefined): Observable<UpdateProfileResponseApiResponse> {
        let url_ = this.baseUrl + "/api/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateProfileResponseApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateProfileResponseApiResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateProfileResponseApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateProfileResponseApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateProfileResponseApiResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ViewInvoiceCorporateService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: string | undefined): Observable<InvoiceViewDtoApiResponse> {
        let url_ = this.baseUrl + "/api/view-invoice-corporate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceViewDtoApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceViewDtoApiResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InvoiceViewDtoApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceViewDtoApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceViewDtoApiResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getEmails(id: string | undefined): Observable<InvoiceEmailLogDtoListApiResponse> {
        let url_ = this.baseUrl + "/api/view-invoice-corporate/emails?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceEmailLogDtoListApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceEmailLogDtoListApiResponse>;
        }));
    }

    protected processGetEmails(response: HttpResponseBase): Observable<InvoiceEmailLogDtoListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceEmailLogDtoListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceEmailLogDtoListApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getEmail(purchaseId: number, studentId: number, mId: number): Observable<InvoiceEmailPreviewDtoApiResponse> {
        let url_ = this.baseUrl + "/api/view-invoice-corporate/emails/{purchaseId}/{studentId}/{mId}";
        if (purchaseId === undefined || purchaseId === null)
            throw new globalThis.Error("The parameter 'purchaseId' must be defined.");
        url_ = url_.replace("{purchaseId}", encodeURIComponent("" + purchaseId));
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        if (mId === undefined || mId === null)
            throw new globalThis.Error("The parameter 'mId' must be defined.");
        url_ = url_.replace("{mId}", encodeURIComponent("" + mId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceEmailPreviewDtoApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceEmailPreviewDtoApiResponse>;
        }));
    }

    protected processGetEmail(response: HttpResponseBase): Observable<InvoiceEmailPreviewDtoApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceEmailPreviewDtoApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceEmailPreviewDtoApiResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ViewInvoiceSalesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(purchaseId: number): Observable<PurchaseInvoiceDtoApiResponse> {
        let url_ = this.baseUrl + "/api/view-invoice-sales/purchases/{purchaseId}";
        if (purchaseId === undefined || purchaseId === null)
            throw new globalThis.Error("The parameter 'purchaseId' must be defined.");
        url_ = url_.replace("{purchaseId}", encodeURIComponent("" + purchaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseInvoiceDtoApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseInvoiceDtoApiResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PurchaseInvoiceDtoApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseInvoiceDtoApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseInvoiceDtoApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    sendEmail(purchaseId: number): Observable<SendInvoiceEmailResultDtoApiResponse> {
        let url_ = this.baseUrl + "/api/view-invoice-sales/purchases/{purchaseId}/email";
        if (purchaseId === undefined || purchaseId === null)
            throw new globalThis.Error("The parameter 'purchaseId' must be defined.");
        url_ = url_.replace("{purchaseId}", encodeURIComponent("" + purchaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendInvoiceEmailResultDtoApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendInvoiceEmailResultDtoApiResponse>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<SendInvoiceEmailResultDtoApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendInvoiceEmailResultDtoApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendInvoiceEmailResultDtoApiResponse>(null as any);
    }
}

export class ArchivedSiteDto implements IArchivedSiteDto {
    id?: number;
    pageName?: string | undefined;
    corporateClient?: string | undefined;

    constructor(data?: IArchivedSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageName = _data["pageName"];
            this.corporateClient = _data["corporateClient"];
        }
    }

    static fromJS(data: any): ArchivedSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivedSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageName"] = this.pageName;
        data["corporateClient"] = this.corporateClient;
        return data;
    }
}

export interface IArchivedSiteDto {
    id?: number;
    pageName?: string | undefined;
    corporateClient?: string | undefined;
}

export class ArchivedSiteDtoListApiResponse implements IArchivedSiteDtoListApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: ArchivedSiteDto[] | undefined;
    version?: string | undefined;

    constructor(data?: IArchivedSiteDtoListApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ArchivedSiteDto.fromJS(item));
            }
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ArchivedSiteDtoListApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivedSiteDtoListApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        return data;
    }
}

export interface IArchivedSiteDtoListApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: ArchivedSiteDto[] | undefined;
    version?: string | undefined;
}

export class InvoiceEmailLogDto implements IInvoiceEmailLogDto {
    id?: number;
    purchaseId?: number | undefined;
    studentId?: number | undefined;
    emailName?: string | undefined;
    subject?: string | undefined;
    fromAddress?: string | undefined;
    toAddress?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;

    constructor(data?: IInvoiceEmailLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseId = _data["purchaseId"];
            this.studentId = _data["studentId"];
            this.emailName = _data["emailName"];
            this.subject = _data["subject"];
            this.fromAddress = _data["fromAddress"];
            this.toAddress = _data["toAddress"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
        }
    }

    static fromJS(data: any): InvoiceEmailLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmailLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseId"] = this.purchaseId;
        data["studentId"] = this.studentId;
        data["emailName"] = this.emailName;
        data["subject"] = this.subject;
        data["fromAddress"] = this.fromAddress;
        data["toAddress"] = this.toAddress;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        return data;
    }
}

export interface IInvoiceEmailLogDto {
    id?: number;
    purchaseId?: number | undefined;
    studentId?: number | undefined;
    emailName?: string | undefined;
    subject?: string | undefined;
    fromAddress?: string | undefined;
    toAddress?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
}

export class InvoiceEmailLogDtoListApiResponse implements IInvoiceEmailLogDtoListApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: InvoiceEmailLogDto[] | undefined;
    version?: string | undefined;

    constructor(data?: IInvoiceEmailLogDtoListApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InvoiceEmailLogDto.fromJS(item));
            }
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): InvoiceEmailLogDtoListApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmailLogDtoListApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        return data;
    }
}

export interface IInvoiceEmailLogDtoListApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: InvoiceEmailLogDto[] | undefined;
    version?: string | undefined;
}

export class InvoiceEmailPreviewDto implements IInvoiceEmailPreviewDto {
    invoiceHtml?: string | undefined;
    toAddress?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    subject?: string | undefined;

    constructor(data?: IInvoiceEmailPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceHtml = _data["invoiceHtml"];
            this.toAddress = _data["toAddress"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any): InvoiceEmailPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmailPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceHtml"] = this.invoiceHtml;
        data["toAddress"] = this.toAddress;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        data["subject"] = this.subject;
        return data;
    }
}

export interface IInvoiceEmailPreviewDto {
    invoiceHtml?: string | undefined;
    toAddress?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    subject?: string | undefined;
}

export class InvoiceEmailPreviewDtoApiResponse implements IInvoiceEmailPreviewDtoApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: InvoiceEmailPreviewDto;
    version?: string | undefined;

    constructor(data?: IInvoiceEmailPreviewDtoApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? InvoiceEmailPreviewDto.fromJS(_data["data"]) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): InvoiceEmailPreviewDtoApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmailPreviewDtoApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IInvoiceEmailPreviewDtoApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: InvoiceEmailPreviewDto;
    version?: string | undefined;
}

export class InvoiceViewDto implements IInvoiceViewDto {
    isOrder?: boolean;
    number?: number;
    invoiceHtml?: string | undefined;
    salesPersonName?: string | undefined;
    date?: Date | undefined;
    studentName?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
    grossSale?: number | undefined;
    netSale?: number | undefined;
    discountCode?: string | undefined;
    authCode?: string | undefined;
    corpName?: string | undefined;
    transactionId?: string | undefined;
    phone?: string | undefined;
    affiliate?: string | undefined;
    creditBankingFee?: number | undefined;
    cc4Digit?: string | undefined;
    salesPersonUrl?: string | undefined;
    corporateUrl?: string | undefined;
    affiliateUrl?: string | undefined;

    constructor(data?: IInvoiceViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOrder = _data["isOrder"];
            this.number = _data["number"];
            this.invoiceHtml = _data["invoiceHtml"];
            this.salesPersonName = _data["salesPersonName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.studentName = _data["studentName"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.grossSale = _data["grossSale"];
            this.netSale = _data["netSale"];
            this.discountCode = _data["discountCode"];
            this.authCode = _data["authCode"];
            this.corpName = _data["corpName"];
            this.transactionId = _data["transactionId"];
            this.phone = _data["phone"];
            this.affiliate = _data["affiliate"];
            this.creditBankingFee = _data["creditBankingFee"];
            this.cc4Digit = _data["cc4Digit"];
            this.salesPersonUrl = _data["salesPersonUrl"];
            this.corporateUrl = _data["corporateUrl"];
            this.affiliateUrl = _data["affiliateUrl"];
        }
    }

    static fromJS(data: any): InvoiceViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOrder"] = this.isOrder;
        data["number"] = this.number;
        data["invoiceHtml"] = this.invoiceHtml;
        data["salesPersonName"] = this.salesPersonName;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["studentName"] = this.studentName;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["grossSale"] = this.grossSale;
        data["netSale"] = this.netSale;
        data["discountCode"] = this.discountCode;
        data["authCode"] = this.authCode;
        data["corpName"] = this.corpName;
        data["transactionId"] = this.transactionId;
        data["phone"] = this.phone;
        data["affiliate"] = this.affiliate;
        data["creditBankingFee"] = this.creditBankingFee;
        data["cc4Digit"] = this.cc4Digit;
        data["salesPersonUrl"] = this.salesPersonUrl;
        data["corporateUrl"] = this.corporateUrl;
        data["affiliateUrl"] = this.affiliateUrl;
        return data;
    }
}

export interface IInvoiceViewDto {
    isOrder?: boolean;
    number?: number;
    invoiceHtml?: string | undefined;
    salesPersonName?: string | undefined;
    date?: Date | undefined;
    studentName?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
    grossSale?: number | undefined;
    netSale?: number | undefined;
    discountCode?: string | undefined;
    authCode?: string | undefined;
    corpName?: string | undefined;
    transactionId?: string | undefined;
    phone?: string | undefined;
    affiliate?: string | undefined;
    creditBankingFee?: number | undefined;
    cc4Digit?: string | undefined;
    salesPersonUrl?: string | undefined;
    corporateUrl?: string | undefined;
    affiliateUrl?: string | undefined;
}

export class InvoiceViewDtoApiResponse implements IInvoiceViewDtoApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: InvoiceViewDto;
    version?: string | undefined;

    constructor(data?: IInvoiceViewDtoApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? InvoiceViewDto.fromJS(_data["data"]) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): InvoiceViewDtoApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceViewDtoApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IInvoiceViewDtoApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: InvoiceViewDto;
    version?: string | undefined;
}

export class ProfileDto implements IProfileDto {
    title?: string | undefined;
    prefix?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleInitial?: string | undefined;
    suffix?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    suite?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    homePhone?: string | undefined;
    cellPhone?: string | undefined;
    faxPhone?: string | undefined;
    ssn?: string | undefined;

    constructor(data?: IProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleInitial = _data["middleInitial"];
            this.suffix = _data["suffix"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.suite = _data["suite"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.homePhone = _data["homePhone"];
            this.cellPhone = _data["cellPhone"];
            this.faxPhone = _data["faxPhone"];
            this.ssn = _data["ssn"];
        }
    }

    static fromJS(data: any): ProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleInitial"] = this.middleInitial;
        data["suffix"] = this.suffix;
        data["password"] = this.password;
        data["email"] = this.email;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["suite"] = this.suite;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["homePhone"] = this.homePhone;
        data["cellPhone"] = this.cellPhone;
        data["faxPhone"] = this.faxPhone;
        data["ssn"] = this.ssn;
        return data;
    }
}

export interface IProfileDto {
    title?: string | undefined;
    prefix?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleInitial?: string | undefined;
    suffix?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    suite?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    homePhone?: string | undefined;
    cellPhone?: string | undefined;
    faxPhone?: string | undefined;
    ssn?: string | undefined;
}

export class ProfileDtoApiResponse implements IProfileDtoApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: ProfileDto;
    version?: string | undefined;

    constructor(data?: IProfileDtoApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? ProfileDto.fromJS(_data["data"]) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ProfileDtoApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDtoApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IProfileDtoApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: ProfileDto;
    version?: string | undefined;
}

export class PurchaseInvoiceDto implements IPurchaseInvoiceDto {
    invoiceHtml?: string | undefined;
    billerEmail?: string | undefined;
    namePrompt?: string | undefined;
    billerName?: string | undefined;

    constructor(data?: IPurchaseInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceHtml = _data["invoiceHtml"];
            this.billerEmail = _data["billerEmail"];
            this.namePrompt = _data["namePrompt"];
            this.billerName = _data["billerName"];
        }
    }

    static fromJS(data: any): PurchaseInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceHtml"] = this.invoiceHtml;
        data["billerEmail"] = this.billerEmail;
        data["namePrompt"] = this.namePrompt;
        data["billerName"] = this.billerName;
        return data;
    }
}

export interface IPurchaseInvoiceDto {
    invoiceHtml?: string | undefined;
    billerEmail?: string | undefined;
    namePrompt?: string | undefined;
    billerName?: string | undefined;
}

export class PurchaseInvoiceDtoApiResponse implements IPurchaseInvoiceDtoApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: PurchaseInvoiceDto;
    version?: string | undefined;

    constructor(data?: IPurchaseInvoiceDtoApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? PurchaseInvoiceDto.fromJS(_data["data"]) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): PurchaseInvoiceDtoApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseInvoiceDtoApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IPurchaseInvoiceDtoApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: PurchaseInvoiceDto;
    version?: string | undefined;
}

export class SendInvoiceEmailResultDto implements ISendInvoiceEmailResultDto {
    sent?: boolean;
    message?: string | undefined;

    constructor(data?: ISendInvoiceEmailResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sent = _data["sent"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendInvoiceEmailResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendInvoiceEmailResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sent"] = this.sent;
        data["message"] = this.message;
        return data;
    }
}

export interface ISendInvoiceEmailResultDto {
    sent?: boolean;
    message?: string | undefined;
}

export class SendInvoiceEmailResultDtoApiResponse implements ISendInvoiceEmailResultDtoApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: SendInvoiceEmailResultDto;
    version?: string | undefined;

    constructor(data?: ISendInvoiceEmailResultDtoApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? SendInvoiceEmailResultDto.fromJS(_data["data"]) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): SendInvoiceEmailResultDtoApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendInvoiceEmailResultDtoApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface ISendInvoiceEmailResultDtoApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: SendInvoiceEmailResultDto;
    version?: string | undefined;
}

export class SignInRequest implements ISignInRequest {
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: ISignInRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SignInRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignInRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ISignInRequest {
    email?: string | undefined;
    password?: string | undefined;
}

export class SignInResponse implements ISignInResponse {
    accessToken?: string | undefined;
    expiresAt?: Date;

    constructor(data?: ISignInResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SignInResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignInResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ISignInResponse {
    accessToken?: string | undefined;
    expiresAt?: Date;
}

export class SignInResponseApiResponse implements ISignInResponseApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: SignInResponse;
    version?: string | undefined;

    constructor(data?: ISignInResponseApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? SignInResponse.fromJS(_data["data"]) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): SignInResponseApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignInResponseApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface ISignInResponseApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: SignInResponse;
    version?: string | undefined;
}

export class UpdateProfileRequest implements IUpdateProfileRequest {
    title?: string | undefined;
    prefix?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleInitial?: string | undefined;
    suffix?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    suite?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    homePhone?: string | undefined;
    cellPhone?: string | undefined;
    faxPhone?: string | undefined;
    ssn?: string | undefined;

    constructor(data?: IUpdateProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleInitial = _data["middleInitial"];
            this.suffix = _data["suffix"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.suite = _data["suite"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.homePhone = _data["homePhone"];
            this.cellPhone = _data["cellPhone"];
            this.faxPhone = _data["faxPhone"];
            this.ssn = _data["ssn"];
        }
    }

    static fromJS(data: any): UpdateProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleInitial"] = this.middleInitial;
        data["suffix"] = this.suffix;
        data["password"] = this.password;
        data["email"] = this.email;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["suite"] = this.suite;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["homePhone"] = this.homePhone;
        data["cellPhone"] = this.cellPhone;
        data["faxPhone"] = this.faxPhone;
        data["ssn"] = this.ssn;
        return data;
    }
}

export interface IUpdateProfileRequest {
    title?: string | undefined;
    prefix?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleInitial?: string | undefined;
    suffix?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    suite?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    homePhone?: string | undefined;
    cellPhone?: string | undefined;
    faxPhone?: string | undefined;
    ssn?: string | undefined;
}

export class UpdateProfileResponse implements IUpdateProfileResponse {
    profile?: ProfileDto;
    accessToken?: string | undefined;

    constructor(data?: IUpdateProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profile = _data["profile"] ? ProfileDto.fromJS(_data["profile"]) : undefined as any;
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): UpdateProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profile"] = this.profile ? this.profile.toJSON() : undefined as any;
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface IUpdateProfileResponse {
    profile?: ProfileDto;
    accessToken?: string | undefined;
}

export class UpdateProfileResponseApiResponse implements IUpdateProfileResponseApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: UpdateProfileResponse;
    version?: string | undefined;

    constructor(data?: IUpdateProfileResponseApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? UpdateProfileResponse.fromJS(_data["data"]) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): UpdateProfileResponseApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileResponseApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IUpdateProfileResponseApiResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: UpdateProfileResponse;
    version?: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}